import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {experiments_post, experiments_view} from "../../service/apis";
import auth from '../../service/Auth';
import {Alert, AlertTitle} from "@material-ui/lab";
import {Link} from "react-router-dom";


const config = window.config;

export default function DataInfo(props){


    const [visible, setVisible] = useState(0);
    const [isOwner, setOwner] = useState(0);
    const [noFiles, setNoFiles] = useState(0);
    const [ready, setReady] = useState(0);



    const [init, setInit] = useState(false);

    useEffect(function(){

        // get visible

        if(!init){
            let basic_body = {"page":1,"pageSize":10,"fields":["Owner","ExperimentID"],"filtered":[],"sorted":[],"aggregates":["Owner"]};


            let user_groups = auth.getUserGroups();
            let isOwner = {"page":1,"pageSize":10,"fields":["Owner","ExperimentID"],"filtered":[{id: "Owner", value: user_groups}],"sorted":[],"aggregates":["Owner"]};
            let inPlatform = {"page":1,"pageSize":10,"fields":["Owner","ExperimentID"],"filtered":[{"id":"in_platform", "value": ["true"]}],"sorted":[],"aggregates":["Owner"]};
            let submission_not_completed = {"page":1,"pageSize":1,"fields":["LocalExperimentID","Participant_ID","Owner","ExperimentID","LOADDATE"],"filtered":[{"id":"Owner","value":user_groups},{"id":"file_submission_close","value":["false"]}]}

            experiments_view(auth.getToken(), config.api_endpoint, JSON.stringify(basic_body) ).then(r => r.json()).then(json => {
                let data = json["_meta"];
                setVisible(data.total_items);
            })
            experiments_view(auth.getToken(), config.api_endpoint, JSON.stringify(isOwner) ).then(r => r.json()).then(json => {
                let data = json["_meta"];
                setOwner(data.total_items);
            })
            experiments_view(auth.getToken(), config.api_endpoint, JSON.stringify(submission_not_completed) ).then(r => r.json()).then(json => {
                let data = json["_meta"];
                setNoFiles(data.total_items);
            })
            experiments_view(auth.getToken(), config.api_endpoint, JSON.stringify(inPlatform) ).then(r => r.json()).then(json => {
                let data = json["_meta"];
                setReady(data.total_items);
            })
            setInit(true);
        }
    })


    return <React.Fragment>
        <Box p={2}>
            <Grid container direction={"row"} spacing={0}>
                <Grid item lg={12}>
                    <Box p={1}><Typography align= {"center"} variant={"h6"}>Your data</Typography></Box>
                </Grid>
                <Grid item lg={3}>
                    <Link to={"/experiments"}>
                        <div className={"data_info"}>
                            <Alert severity="success">
                                <AlertTitle style={{fontSize: "20px"}}> Visible experiments</AlertTitle>
                                <Typography variant={"h6"}> {visible} </Typography>
                                <Typography variant={"subtitle2"}>Click to browse experiments</Typography>
                            </Alert>
                        </div>
                    </Link>
                </Grid>
                <Grid item lg={3}>
                    <Link to={{pathname: "/experiments"}}>
                    <div className={"data_info"}>
                        <Alert severity="success">
                            <AlertTitle style={{fontSize: "20px"}}> Submitted experiments</AlertTitle>
                            <Typography variant={"h6"}>{isOwner} </Typography>
                            <Typography variant={"subtitle2"}>You are the owner of these experiments</Typography>
                        </Alert>
                    </div>
                    </Link>
                </Grid>
                <Grid item lg={3}>
                    <Link to={"/selectexperiments"}>
                        <div className={"data_info"}>
                            <Alert severity="warning">
                                <AlertTitle style={{fontSize: "20px"}}> Uncompleted submissions </AlertTitle>
                                <Typography variant={"h6"}>{noFiles}</Typography>
                                <Typography variant={"subtitle2"}>Click to go to Review your Experiments</Typography>
                            </Alert>
                        </div>
                    </Link>
                </Grid>
                <Grid item lg={3}>
                    <Link to={"/nextgpap"} target={"_blank"}>
                    <div className={"data_info"}>
                        <Alert severity="success">
                            <AlertTitle style={{fontSize: "20px"}}> Ready for Genomic Analysis</AlertTitle>
                            <Typography variant={"h6"}> {ready} </Typography>
                            <Typography variant={"subtitle2"}>Click to go to the Genomic Analysis Module</Typography>
                        </Alert>
                    </div>
                    </Link>
                </Grid>

            </Grid>
        </Box >
        <hr className="yellowDivider"/>
        <Box p={2}>
        </Box>
    </React.Fragment>
}
